import { Channel } from 'actioncable'
import { makeChannel } from '../../../action_cable/cable'

class TrackingLesson {
  private schoolId = 0
  private lessonId = 0
  private trackingChannel: Channel

  constructor() {
    this.trackingChannel = makeChannel('TrackingChannel')

    // ブラウザーが閉じる時、自動的にStopする
    window.addEventListener('beforeunload', (e) => {
      this.stop()
    })
  }

  start(schoolId: number, lessonId: number) {
    // TrackingしているレッスンをStopする
    if (this.lessonId) {
      this.stop()
    }

    this.lessonId = lessonId
    this.schoolId = schoolId

    this.trackingChannel.perform('start_lesson', {
      school_id: this.schoolId,
      lesson_id: this.lessonId
    })
  }

  stop() {
    if (this.lessonId) {
      this.trackingChannel.perform('stop_lesson', {
        school_id: this.schoolId,
        lesson_id: this.lessonId
      })
    }

    this.schoolId = 0
    this.lessonId = 0
  }
}

const trackingLesson = new TrackingLesson()
export default trackingLesson
